enum QsrAutomationsMode {
  Sending = 'sending-and-webhooks',
  PosWebhooks = 'pos-webhooks',
}

export { QsrAutomationsMode };
